import withHelmet from '../HOC/withHelmet';
import TermsOfServicePage from '../components/terms-of-service';

export default withHelmet(TermsOfServicePage, 'Terms of service');
